import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-our-features',
  templateUrl: './our-features.component.html',
  styleUrl: './our-features.component.css'
})
export class OurFeaturesComponent {
  //Services
  leftFeatures = [
    {
      icon: 'bi-lightbulb',
      title: 'Creative Vision',
      desc: 'We craft unique ideas and bring them to life through bold visual storytelling and branding.'
    },
    {
      icon: 'bi-trophy',
      title: 'Award-Winning Work',
      desc: 'Recognized by top design institutions for our impactful and engaging digital campaigns.'
    }
  ];

  rightFeatures = [
    {
      icon: 'bi-people',
      title: 'Experienced Team',
      desc: 'Our talented designers, developers, and strategists collaborate to build memorable brands.'
    },
    {
      icon: 'bi-headset',
      title: 'Reliable Support',
      desc: 'We offer dedicated support and communication throughout your project and beyond launch.'
    }
  ];

  // OWl Slider
    brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "vendor-1.jpg"},
    {img: "vendor-2.jpg"},
    {img: "vendor-3.jpg"},
    {img: "vendor-4.jpg"},
    {img: "vendor-5.jpg"},
    {img: "vendor-6.jpg"}
  ];
}
